export default __webpack_public_path__ + "static/fotel_podologiczny_mini-6c427c7aadcd8cbbf11fc4ad00e264e0.jpg";